export default {
  namespaced: true,
  simulacrum: {
    title: "Simulacro",
    simulacrums_title: "Simulacros",
    new: "Novo Simulacro",
    reference_number: "Número de Referência",
    select_form: "Selecione formulários",
    select_form_place_holder: "Selecione um formulário",
    selected_form: "Formulário selecionado",
    answer_form: "Iniciar formulário",
    start_form: "Iniciar formulário",
    confirm_delete: "Tem certeza que deseja excluir este simulacro?",
    no_records: "Nenhum simulacro encontrado",
    reassign: "Reatribuir",
    template: {
      title: "Modelos de formulário",
      question: "Pergunta | Perguntas",
      options: "Opções",
    },
    confirm_cancel: "Tem certeza de que deseja cancelar este simulacro?",
    canceled: "Simulacro cancelado",
  },
};


